const REWARD_TYPE = {
  BONUS_POINTS: 'A',
  FOOD_CREDIT: 'F',
  FREE_PLAY: 'P',
  SHOPPING_DOLLARS: 'shopping-dollars',
  HOTEL_STAY: 'R',
  DEFAULT: 'default'
};

const rewardTierData = [
  {
    tierName: 'Fantasy',
    minPoints: 200000
  },
  {
    tierName: 'Delight',
    minPoints: 50000
  },
  {
    tierName: 'Escape',
    minPoints: 20000
  },
  {
    tierName: 'Play',
    minPoints: 500
  },
  {
    tierName: 'Chance',
    minPoints: 0
  }
];

function lookupRewardTier(basePoints) {
  let max = undefined;
  let next = undefined;
  let min, tier;

  let i = 0;
  for (; i < rewardTierData.length; ++i) {
    min = rewardTierData[i].minPoints;
    tier = rewardTierData[i].tierName;
    if (basePoints >= min) {
      break;
    } else {
      max = min;
      next = tier;
    }
  }

  return {
    rewardTier: tier,
    nextRewardTier: next,
    rewardTierMin: min,
    rewardTierMax: max
  };
}

export { REWARD_TYPE, lookupRewardTier };



// WEBPACK FOOTER //
// ./src/utils/rewards.js